export default __webpack_public_path__ + "static/media/Boton Rojo.93cd8ac9.svg";